import { RootDispatch, MessageHeaderActionType } from "../types";
import { get } from "../../utils/fetch";
export const removeMessageBadge = () => (dispatch: RootDispatch) => {
  dispatch({
    type: MessageHeaderActionType.REMOVE_MESSAGE_BADGE
  });
};
export const addMessageBadge = () => (dispatch: RootDispatch) => {
  dispatch({
    type: MessageHeaderActionType.ADD_MESSAGE_BADGE
  });
};

export const getUnreadCount = () => async (dispatch: RootDispatch) => {
  const url = "/api/conversations/unread_count/";

  const resp = await get<{ unreadCount: number }>(url);

  if (resp.error) {
    return;
  } else if (resp.data) {
    // Check to see if the data is greater than zero
    if (resp.data.unreadCount > 0) {
      dispatch(addMessageBadge());
    } else {
      dispatch(removeMessageBadge());
    }
  } else {
    // TODO Logging
  }
};
